import * as R from 'ramda';
import tracking from 'modules/tracking';

tracking.init('replace_with_tracking_token');

const nameSpace = R.concat('ChallengesCarousel::');

export const track = (eventName, props) => tracking.track(nameSpace(eventName), props);
